import React from 'react';
import PropTypes from 'prop-types';
import css from './HistoryRow.css';
import moment from 'moment';
import StudentsCell from './StudentsCell';
import RowButton from './RowButton';
import MeetingType from './MeetingType';
import ExtraRow from './ExtraRow';

function HistoryRow(props) {
  const isGroupSession = props.appointment.type === "GROUP_SESSION";

  const isSelfService = props.appointment.type === "SELF_SERVICE";

  // Every meeting that is either a group session or has an appointment id can be edited
  const canEditMeeting = isGroupSession || props.appointment.studentAppointment[0].appointmentId > 0;

  const startDate = props.appointment.studentAppointment
    .map(appointment => appointment.checkInDate)
    .sort()[0];

  const endDate = props.appointment.studentAppointment
    .map(appointment => appointment.checkOutDate)
    .sort()
    .reverse()[0];

  const extJSAppointment = {
    id: isGroupSession
      ? props.appointment.scheduleBlockId 
      : props.appointment.studentAppointment[0].appointmentId,
    participants: props.appointment.studentAppointment,
    startDate: props.appointment.studentAppointment[0].scheduledStartDate,
    endDate: props.appointment.studentAppointment[0].scheduledEndDate,
  };

  const editAppointment = () => props
    .editAppointment(null, extJSAppointment, props.getAppointmentsHistory);

  const handleGroupSession = () => props
    .handleGroupSession(null, extJSAppointment, "Manage Participants", props.getAppointmentsHistory);
  
  const getFormattedDate = date => props.formatDate(moment(date).toDate(), 'timeDisplayFormat');

  const getParticipantDescription = participant => {
    if ( participant.description ) return participant.description;
    if ( !participant.dequeuedBy ) return "Student was removed by the system";
    return "No description provided.";
  }
  
  const getMeetingDescription = () => {
    return isGroupSession
      ? props.appointment.studentAppointment
        .map(participant => `${participant.firstName} ${participant.lastName}:<br>${getParticipantDescription(participant)}`)
        .join("<br><br>")
      : getParticipantDescription(props.appointment.studentAppointment[0]);
  }

  return (
    <React.Fragment>
      <tr 
        className={props.isExpanded ? css['selected-top-row'] : null}
        aria-expanded={props.isExpanded}>
        <StudentsCell
          groupSession={isGroupSession}
          participants={props.appointment.studentAppointment}
          openStudentFolder={props.openStudentFolder}
          handleGroupSession={handleGroupSession}
        />
        <td><MeetingType type={props.appointment.type} /></td>
        <td>{props.appointment.reasonName}</td>
        <td>{props.appointment.serviceName}</td>
        <td>{getFormattedDate(startDate)}</td>
        <td>{getFormattedDate(endDate)}</td>
        <td className={css['button-container']}>
          <div>
            {canEditMeeting && <RowButton
              icon="edit"
              label="Edit meeting details"
              onClick={isGroupSession ? handleGroupSession : editAppointment}
            />}
            <RowButton
              icon={props.isExpanded ? "arrow_drop_up" : "arrow_drop_down"} 
              label={`${props.isExpanded ? "Collapse" : "Expand"} details`}
              onClick={props.onDropdownClick}
            />
          </div>
        </td>
      </tr>
      {props.isExpanded && <ExtraRow 
        description={getMeetingDescription()}
        selfService={isSelfService}
        setError={props.setError}
        getAppointmentsHistory={props.getAppointmentsHistory}
        appointment={props.appointment}
      />}
    </React.Fragment>
  );
}

HistoryRow.propTypes = {  
  appointment: PropTypes.object.isRequired,
  openStudentFolder: PropTypes.func.isRequired,
  editAppointment: PropTypes.func.isRequired,
  handleGroupSession: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  getAppointmentsHistory: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onDropdownClick: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default HistoryRow;
